module.exports = __webpack_public_path__ + "img/content_project.47c57255.svg";